import React, { useState } from "react";
import Burger from "./burger";
import MobileMenu from "./mobileMenu";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const MobileMenuWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  position: "fixed",
  zIndex: theme.zIndex.appBar,
}));

const MobileNavBarSpacer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100vw",
  height: "80px",
}));

export const MobileWarningWrapper = styled("div")(({ theme }) => ({
  display: "none", // By default, it will not display
  position: "absolute",
  zIndex: 1,
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.primary.dark,
  borderRadius: "3rem",
  padding: theme.spacing(2),
  bottom: theme.spacing(4), // 2rem above the bottom edge
  left: theme.spacing(2),
  right: theme.spacing(2),
  boxShadow: theme.shadows[4],

  [theme.breakpoints.down("md")]: {
    display: "flex", // Will display on screens smaller than 800px
  },
}));

const WarningText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  textAlign: "center",
  fontSize: "0.9rem",
  fontFamily: theme.typography.body2.fontFamily,
}));

const MobileNav = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <MobileMenuWrapper>
        <MobileNavBarSpacer />
        <Burger
          open={open}
          setOpen={setOpen}
          stillLoading={props.stillLoading}
        />
        <MobileMenu
          userData={props.userData}
          authUser={props.authUser}
          open={open}
          setOpen={setOpen}
        />
      </MobileMenuWrapper>
      <MobileWarningWrapper>
        <WarningText>
          Accounting work on mobile is really tough. We recommend you work on a
          larger screen to display these tables.
        </WarningText>
      </MobileWarningWrapper>
    </React.Fragment>
  );
};

export default MobileNav;
